/*
 * Copyright (c) 2020. Sonrai Analytics Ltd.
 * Developed by Ryan Duffy
 */

export class NotificationUserModel {
  notificationId: string;
  userId: string;

  constructor(notificationId?: string, userId?: string) {
    this.notificationId = notificationId;
    this.userId = userId;
  }

  toJson(): Object {
    const object = {
      notification_id: this.notificationId,
      user_id: this.userId,
    };
    Object.keys(object).forEach(
      (k) =>
        !object[k] && typeof object[k] !== 'boolean' && object[k] !== undefined && delete object[k]
    );
    return object;
  }

  fromJson(input: any): NotificationUserModel {
    return new NotificationUserModel(input['notification_id'], input['user_id']);
  }
}
